import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/VisionStrategy/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__content')}>
          <div className={cn('about__logo-container')}>
            <img
              className={cn('about__logo')}
              src='/images/global/logo-new.svg'
              alt='DP World'
            />
          </div>
          <div className={cn('about__description')}>
            <p className={cn('about__paragraph')}>
              To understand the philosophy behind how a wider vision grew
              from this beginning one needs to know that DFA was born from DP
              World and that DP World was born from the cultural background
              of Dubai as an entrepot. As barriers have progressively risen
              to world trade in the last ten years, DP World sees the digital
              revolution as an alternative engine to create growth.
            </p>
            <p className={cn('about__paragraph')}>
              To deliver this growth however we must provide the opportunity
              for SME forwarders to digitize, to compete with large scale players
              who are digitizing at scale. SME forwarders who are able to
              “go global” are the key to prosperity, we believe.
            </p>
          </div>
        </div>

        <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="
                /images/pages/Company/VisionAndStrategy/office.webp 1x,
                /images/pages/Company/VisionAndStrategy/office@2x.webp 2x
              "
              sizes='100vw'
            />
            <img
              className={cn('about__image')}
              src='/images/pages/Company/VisionAndStrategy/office.webp'
              alt='DP World'
            />
          </picture>
        </div>

      </div>
    </section>
  );
};

export default SectionAbout;